module.exports = __webpack_public_path__ + "static/img/products discription_pu3.ee10f25b.jpg";